const modifyCrowdStrikeLink = ({ domain, url }) => {
    let baseCrowdStrikeURL = 'https://falcon.<domain>.crowdstrike.com/';

    if (domain && domain !== 'us-1') {
        baseCrowdStrikeURL = baseCrowdStrikeURL.replace('<domain>', domain);
    } else {
        baseCrowdStrikeURL = 'https://falcon.crowdstrike.com/';
    }

    if (url) return url.replace('https://falcon.crowdstrike.com/', baseCrowdStrikeURL);
    return `${baseCrowdStrikeURL}search?query=....`;
};

export default modifyCrowdStrikeLink;